import React from 'react';
import Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';
import moment from 'moment';
import './VehicleResult.scss';

const CustomDatePicker = ({ selectedDate, onChange }) => {
  const valid = (current) => {
    return current.isSameOrAfter(moment(), 'day');
  };

  return (
    <div className="custom-date-picker">
      <Datetime
        value={selectedDate ? moment(selectedDate) : null}
        onChange={onChange}
        timeFormat={false}
        dateFormat="YYYY-MM-DD"
        isValidDate={valid}
        inputProps={{ placeholder: 'Select Date', readOnly: true }}
      />
    </div>
  );
};

export default CustomDatePicker;
